export default __webpack_public_path__ + "static/media/onboardingAsideMb.8aad08b1.png";